import * as yup from "yup";

export const basicSchema = yup.object().shape({
  title: yup.string()
  .required("Name required")
});